import request from '@/router/axios';

const base = '/api/produce/railway-unload-line-efficiency';

export const fetchDashboard = (data) =>
  request({ url: `${base}/dashboard`, method: 'post', data });

export const fetchDetailPage = (data) =>
  request({ url: `${base}/detailPage`, method: 'post', data });

export const fetchTeamOptions = (params) =>
  request({
    url: '/api/produce/produce-team/select/page',
    method: 'get',
    params: {
      page: 1,
      size: 500,
      ...params
    }
  });
